import React, { useEffect, useState } from "react";
import "./AuthPage.css";
import { Link, useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "./services/auth";
import AuthLeftPanel from "./component/AuthLeftPanel";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [forgotPassword] = useForgotPasswordMutation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!success) return undefined;
    const timer = setTimeout(() => navigate("/login"), 3000);
    return () => clearTimeout(timer);
  }, [success, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await forgotPassword({ email }).unwrap();
      setSuccess(true);
    } catch {
      setError("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <>
      <nav className="auth-nav">
        <Link to="/" className="auth-nav-logo">
          <img
            src="/StratusEdgeFinal_whiteupscaled.png"
            alt="Edge AI"
            className="auth-nav-logo-img"
          />
        </Link>
      </nav>
      <div className="auth-split">
      <AuthLeftPanel variant="login" />
      <div className="auth-split-border" aria-hidden="true" />

      <div className="auth-split-right">
        <div className="auth-form-shell auth-form-animate auth-form-forgot">
          <h2 className="auth-heading">Reset your password</h2>
          <p className="auth-subheading">Enter your email and we&apos;ll send you a reset link.</p>

          {success ? (
            <div className="auth-success-state" role="status">
              <div className="auth-success-icon" aria-hidden="true">✓</div>
              <p className="auth-success-text">Reset link sent! Check your email.</p>
              <p className="auth-success-hint">Redirecting to sign in…</p>
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-input-container">
                <label htmlFor="forgot-email">Email Address</label>
                <input
                  id="forgot-email"
                  type="email"
                  placeholder="you@company.com"
                  className="auth-input auth-input-lg"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>

              {error && <p className="auth-inline-error">{error}</p>}

              <button type="submit" className="auth-button auth-button-primary" disabled={loading}>
                {loading ? (
                  <span className="auth-button-loading">
                    <span className="auth-spinner" aria-hidden="true" />
                    Sending…
                  </span>
                ) : (
                  "Send Reset Link"
                )}
              </button>
            </form>
          )}

          <div className="auth-footer">
            <span>Remembered your password?</span>{" "}
            <Link to="/login" className="auth-link-inline">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ResetPassword;
